export default function bulkDeleteArchivedReportInstanceDirective() {
  return {
    template: require('./bulk-delete-archived-report-instance.html'),
    restrict: 'E',
    controller: 'BulkDeleteArchivedReportInstanceController',
    controllerAs: 'bulkDeleteArchivedReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      reportInstance: '=',
    },
  };
}
